module.exports = __webpack_public_path__ + "img/closed-menu.7c9f9176.svg";